<template>
  <section class="google-map">
    <transition name="fade" mode="out-in">
      <div
        v-if="tollTipShow"
        @click="tollTipShow = false"
        class="google-map__text-wrap"
      >
        <div class="google-map__text-inner-wrap">
          <div class="google-map__text" v-html="toolTip"></div>
          <svg class="google-map__close">
            <use xlink:href="#icon-times-light"></use>
          </svg>
        </div>
      </div>
    </transition>

    <div ref="map" style="width: 100%; height: 100%"></div>
  </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "GoogleMap",
  data() {
    return {
      map: false,
      cityPolygon: false,
      tollTipShow: true,
    };
  },
  methods: {
    ...mapMutations("map", ["setSearchCord", "setIsMapOpen"]),
    ...mapActions("products", ["filterDist", "filterCords"]), 
  
    setMap() {
      
      this.map = new google.maps.Map(this.$refs["map"], {
        center: {
          lat: this.cord.lat,
          lng: this.cord.lng,
        },
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        streetViewControl: false,
        zoom: 15,
      });
      this.setMarker();
      this.setPolygon();
    },
    setMarker() {
      const latLng = new google.maps.LatLng(this.cord.lat, this.cord.lng);
      new google.maps.Marker({
        position: latLng,
        title: "Marker",
        map: this.map,
        draggable: true,
      });
    },
    setPolygon() {
      const cityCircle = new google.maps.Circle({
        center: { lat: this.cord.lat, lng: this.cord.lng },
        radius: this.radius,
      });
      const bounds = cityCircle.getBounds()
      this.cityPolygon = new google.maps.Rectangle({
        strokeColor: "#FFF",
        strokeOpacity: 1,
        strokeWeight: 3,
        fillOpacity: 0,
        map: this.map,
        bounds:  bounds,
      });
      this.cityPolygon.setMap(this.map);
 
      this.cityPolygon.addListener("click", (e) => {
        const cord = e.latLng.toJSON();
        this.setSearchCord(cord);
        this.filterCords();
        if(window.innerWidth < 1200) {
          this.setIsMapOpen()
        }
      });
    },

  },
  computed: {
    ...mapState("products", ["products", "street"]),
    ...mapState("map", ["cord", "radius", "searchCord"]),
    toolTip() {
      return window.mapTollTip;
    },
  },
  mounted() { 
    this.setMap();
  },
};
</script>
